import React, { useState, useEffect, useRef } from 'react';
import { db } from './firebase';
import { doc, onSnapshot } from 'firebase/firestore';
import type { DocumentData } from 'firebase/firestore';
import type { HomeFeedItem } from './services/homeFeedScore';

// ⚠️ Post.css artık import EDİLMİYOR (çakışmayı kesiyoruz)
// import './Post.css';
import './ClipInFeed.css'; // yeni, namespaced stiller
import MyClipsPlayer from './components/MyClipsPlayer';
// PR-1 — limited/emergency modlarında video ön yükleme kapatılır.
import useCostMode, { getCostModeConfig } from './hooks/useCostMode';

// PR-29 — ÜRÜN KURALI: ikili beğeni (begenenler) TAMAMEN KALDIRILDI.
// Yıldız butonu artık GERÇEK 5★ popover'ı (StarRatingV2 self-write →
// content/{clipId}/ratings — MyClips.tsx legacy viewer'la aynı hedef).
import StarRatingV2 from './components/StarRatingV2/StarRatingV2';
import PostActionsBar from "./components/PostActionsBar/PostActionsBar";
import { BsChat, BsBookmark, BsBookmarkFill, BsThreeDots, BsPlayFill } from 'react-icons/bs';
import { FiSend } from 'react-icons/fi';
import { VscMute, VscUnmute } from 'react-icons/vsc';
import { DEFAULT_AVATAR_NEUTRAL } from "./utils/avatar";
import {
  klipManifestUrl, klipVideoUrl, klipPosterUrl, klipSureMetni, klipYorumSayisi,
  type KlipAlanKaynagi,
} from "./utils/klipAlanlari";
/* ── T3 · AKIŞ GÖRÜNÜM PARİTESİ ──────────────────────────────────────────────
   Aşağıdaki yardımcıların hepsi GÖNDERİ kartlarının (Post/PostMobile)
   KULLANDIKLARININ AYNISIDIR — kopya yazılmadı. Gerekçe kanonun kendi vakası:
   `formatTimeAgoShort` bu depoda bir kez çatallanmış ve aynı gönderinin zamanı
   iki kartta iki biçimde yazılmıştı (denetim P2-1). Klip kartı o hataya
   doğuştan girmesin diye TEK OTORİTEDEN tüketiyor. */
import { kisaltAciklama } from "./hooks/usePostLogic";
import { formatTimeAgoShort, formatCount } from "./utils";
import { damgaAttr, baslikAttr } from "./gonderiZamanDamgasi";
// KLİP 5★ TEK OTORİTE — bkz. `src/utils/klipYildizOtoritesi.ts`.
import { klipDokumanindanYildiz } from "./utils/klipYildizOtoritesi";
// ÖZ-PUANLAMA KAPISI (GÖZ §2 · A1) — bkz. `src/utils/ozPuanlamaKapisi.ts`.
import { ozPuanlamaKapali, OZ_PUANLAMA_SEBEBI_KLIP } from "./utils/ozPuanlamaKapisi";
// ── P0-2 · ÜÇ ÖLÜ DÜĞMENİN HATTI ────────────────────────────────────────────
// Hiçbiri yeni icat değil: üçünün de ürün hattı ZATEN VARDI, kart onlara
// bağlanmamıştı (kanon: *"bir olayın gönderilmesi, dinlendiğinin kanıtı
// değildir"* — buradaki hâli: bir hattın var olması, bağlandığının kanıtı değil).
// ADLI import (default DEĞİL): modül ikisini de veriyor ama depodaki mevcut
// mock'lar yalnız adlı yüzü tanımlıyor — default'u kullanmak testte modül
// nesnesini fonksiyon sanmaya yol açardı (alet arızası, ürün bulgusu değil).
import { shareClipV3, SHARE_RESULT } from "./myclipsv3/engagement/shareClipV3";
import { isSaved as kayitliMi, toggleSave } from "./savesClient";
import ReportModal, { SikayetHedefi } from "./components/ReportModal";
import { REPORT_TARGET_TYPE } from "./constants/reportSchema";
import { showToast } from "./ToastBoot";
import { IkonKoprusu } from "./icon-system/runtime/IkonKoprusu";
import { boyutCoz } from "./icon-system/adapters/boyut";

/* 🔴 1a'NIN BİREBİR İKİZİ (ölçülerek bulundu, 2026-09-11).
   `ClipInFeed.css:52` → `.clipDk-optionsBtn svg { width:28px; height:28px }`.
   Motor kolunda `IconFrame` satır-içi `style` yazar ve satır-içi stil stil
   sayfasını EZER → o 28 ölü kalır, kutu `md` (24 px) olur; yani `Post.tsx`te
   ölçülen 28→24 büzülmesinin aynısı bu yüzeyde de olurdu.
   Aynı emsal çözüm: 28, stil sayfasından ÇAĞRI YERİNE taşınır (`boyutCoz` +
   `data-boyut-px`). Yeni sabit-px borcu EKLENMEZ — üründe zaten olan borç
   görünür kılınır. `ClipInFeed.css:52` SİLİNMEZ: eski kolu (Phosphor
   `width`/`height` ÖZNİTELİĞİ) hâlâ o kural boyutlandırır; silmek eski kolu
   24'e düşürürdü.
   Modül seviyesi: render başına nesne yok. Bayrak KAPALI iken yalnız `eski`
   çizilir ve bu nesne hiç okunmaz → piksel-birebir. */
const _clip28 = boyutCoz(28);
const KLIP_MOTOR_BOYUT_28 = {
  boyut: _clip28.boyut,
  kutuPx: _clip28.kutuPx,
  "data-boyut-px": _clip28.borc,
};

/**
 * Akıştaki klip öğesi. ŞEKİL ELLE YAZILMADI: tek çağıran `Feed.tsx:1027`
 * `clip={item}` geçiyor ve orada öğe tipi `HomeFeedItem & DocumentData`
 * (`Feed.tsx:96 AkisOgesi`) — aynı iki parça burada da birleştirildi.
 */
// `KlipAlanKaynagi` eklendi (2026-08-25): akış klibi V3 medya alanlarını
// (`v3_hlsManifestUrl`, `v3_posterUrl`, `v3_r2Url`, `v3_ratingCount`…)
// GERÇEKTEN taşıyor ama tip bunu beyan etmiyordu. Beyan etmeyen tip,
// "yazan alan ≠ okunan alan" kusurunu derleyiciden gizler — bu dosyada
// tam olarak o oldu. `as any` ile geçiştirilmedi: alanlar TİPE yazıldı.
type AkisKlipOgesi = HomeFeedItem & KlipAlanKaynagi & DocumentData;

/**
 * `users/{authorId}` dokümanından okunan alanlar — gövdedeki ad/avatar
 * yedek zincirlerinin ta kendisi (kullaniciAdi · username · displayName ·
 * profilFoto · photoURL).
 */
type KlipYazariProfili = {
  kullaniciAdi?: string;
  username?: string;
  displayName?: string;
  profilFoto?: string;
  photoURL?: string;
};

/**
 * 📏 ÇAĞRI YERİ SAYIMI: `<ClipInFeed` → 1 çağrı (`Feed.tsx:1027`); dört
 * prop da oradaki `Feed` sözleşmesinden geliyor.
 */
/*
 * ⚠️ `clip.authorId` veri tarafında boş olabilir (`HomeFeedItem` onu
 * `string | null` sayar), `Feed`in `onUserClick` sözleşmesi ise `string`.
 * Bugünkü davranış "boş olsa da çağır" — o yüzden aşağıdaki üç çağrıda
 * SIFIR çalışma-zamanı etkisi olan tip köprüsü (`as string`) kullanıldı;
 * guard EKLENMEDİ, yoksa tıklama davranışı sessizce değişirdi.
 */
type ClipInFeedProps = {
  clip: AkisKlipOgesi;
  aktifKullaniciId?: string | null;
  onUserClick?: (uid: string) => void;
  onViewClip?: (clip: AkisKlipOgesi) => void;
};

function ClipInFeed({ clip, aktifKullaniciId, onUserClick, onViewClip }: ClipInFeedProps) {
  const [authorProfile, setAuthorProfile] = useState<KlipYazariProfili | null>(null);
  const [isMuted, setIsMuted] = useState(true);
  const [isSaved, setIsSaved] = useState(false);
  // P0-2 — kart menüsü (`⋯`) + şikayet hedefi. Desen `PostMobile.tsx` ile
  // BİREBİR: `pm-more` sarmalayıcı + dış-tıklama kapanışı + `role="menu"`.
  const [menuAcik, setMenuAcik] = useState(false);
  // T3 — açıklama kısaltma (gönderi kartlarındaki `showFullCaption` ikizi).
  const [aciklamaAcik, setAciklamaAcik] = useState(false);
  const [sikayetHedefi, setSikayetHedefi] = useState<SikayetHedefi | null>(null);
  const menuRef = useRef<HTMLDivElement | null>(null);
  const costMode = useCostMode();
  const { videoPreload } = getCostModeConfig(costMode);

  useEffect(() => {
    if (!clip?.authorId) return;
    const userRef = doc(db, 'users', clip.authorId);
    const unsub = onSnapshot(userRef, (snap) => {
      if (snap.exists()) setAuthorProfile(snap.data());
    });
    return () => unsub();
  }, [clip?.authorId]);

  /* P0-2 · KAYDET KALICI OLDU.
     ÖLÇÜLEN KUSUR (denetim §2): düğme YALNIZ `useState` çeviriyordu —
     sunucuya hiçbir şey yazılmıyor, sayfa yenilenince kayıt kayboluyordu.
     Kullanıcı "kaydettim" sanıyordu. Hat (`savesClient` +
     `users/{uid}/saved/{contentId}`) gönderi kartında ZATEN kullanılıyor;
     eksik olan tek şey bağlantıydı. Mount'ta gerçek durum OKUNUR — yoksa
     kaydedilmiş bir klip kartta "kaydedilmemiş" görünürdü. */
  useEffect(() => {
    let iptal = false;
    if (!clip?.id) return undefined;
    kayitliMi(clip.id)
      .then((v) => { if (!iptal) setIsSaved(!!v); })
      .catch(() => { /* okunamadı → görsel durum değişmez (ÖLÇEMEDİM) */ });
    return () => { iptal = true; };
  }, [clip?.id]);

  // Menü dışına tıklayınca kapan (PostMobile deseni).
  useEffect(() => {
    if (!menuAcik) return undefined;
    const onDoc = (e: MouseEvent | TouchEvent) => {
      const kok = menuRef.current;
      if (kok && e.target instanceof Node && !kok.contains(e.target)) setMenuAcik(false);
    };
    document.addEventListener('mousedown', onDoc);
    document.addEventListener('touchstart', onDoc);
    return () => {
      document.removeEventListener('mousedown', onDoc);
      document.removeEventListener('touchstart', onDoc);
    };
  }, [menuAcik]);

  const toggleMute = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsMuted((m) => !m);
  };

  if (!authorProfile) {
    return (
      <article className="clipDk-card clipDk-skeleton">
        <div className="clipDk-skel-media" />
      </article>
    );
  }

  // TEK OTORİTE — bu yüzey ortalama HESAPLAMAZ, kararı basar.
  const yildiz = klipDokumanindanYildiz(clip);

  /* ÖZ-PUANLAMA KAPISI (GÖZ §2 · A1) — `aktifKullaniciId` bu dosyaya
     ZATEN geliyordu (`Feed.tsx:1086`) ama gövdede SIFIR referansı vardı:
     prop alınıyor, hiç sorulmuyordu. Sonuç, kullanıcının kendi klibinde
     1–5 seçip "Puan kaydedilemedi" hatası almasıydı — sunucu doğru
     davranıyor, arayüz olmayacak bir eylemi teklif ediyordu.
     Emsal #931 (`Post.tsx`): GİZLEME yok, `disabled` + sebep. */
  const kendiKlibim = ozPuanlamaKapali(aktifKullaniciId, clip?.authorId);

  /* T3 — ▶ rozetinin süresi + açıklama kısaltması.
     `kisaltAciklama` GÖNDERİ kartlarıyla aynı eşiği (140) kullanır: aynı
     akışta iki kart tipinin metni iki farklı yerden kesmesi, denetimin
     P2-1'de yakaladığı «aynı veri, iki biçim» kusurunun ta kendisidir. */
  const sureMetni = klipSureMetni(clip);
  const { needsClamp, preview: aciklamaOnizleme, text: aciklamaTam } = kisaltAciklama(clip?.aciklama);
  const yorumAdet = klipYorumSayisi(clip);
  /* TEK ÇAĞRI: `formatTimeAgoShort` `Date.now()` okur, yani SAF DEĞİLDİR.
     İki kez çağrılsaydı koşul ile basılan metin ayrı anlardan gelirdi —
     saniye sınırında koşul "1 sn" görüp geçer, render "" basardı: boş bir
     `<time>` ve kartın dibinde ölü bir bant. Bir kez ölç, iki yerde kullan. */
  const zamanMetni = formatTimeAgoShort(clip?.tarih);

  const username =
    authorProfile?.kullaniciAdi ||
    authorProfile?.username ||
    authorProfile?.displayName ||
    '...';
  const avatarUrl =
    authorProfile?.profilFoto ||
    authorProfile?.photoURL ||
    DEFAULT_AVATAR_NEUTRAL;

  /* ── P0-2 · EYLEMLER ────────────────────────────────────────────────────
     Kanca DEĞİL düz fonksiyon: yukarıdaki `if (!authorProfile) return` erken
     dönüşünün ALTINDAYIZ; burada `useCallback` yazmak kanca sırasını koşullu
     yapardı (React kural ihlali). Kimlik sabitliği gerekmiyor — üçü de
     doğrudan `onClick`e bağlanıyor, memo'lu alt bileşene değil. */

  /* PAYLAŞ — `shareClipV3` (navigator.share → clipboard → execCommand →
     prompt). Zincir yeniden yazılmadı: MyClips V3 rail'i AYNI fonksiyonu
     kullanıyor → akıştan ve tam ekrandan paylaşılan bağlantı BİREBİR aynı
     (`/c/{id}`). Denetim P1-5'in `window.alert`ı buraya HİÇ girmiyor:
     geri bildirim ortak `showToast` ile veriliyor. */
  const paylas = async () => {
    if (!clip?.id) return;
    const sonuc = await shareClipV3({
      clipId: clip.id,
      caption: clip?.aciklama || "",
      authorName: username,
    });
    if (sonuc?.result === SHARE_RESULT.COPIED) showToast("Bağlantı kopyalandı");
    else if (sonuc?.result === SHARE_RESULT.FAILED) showToast("Bağlantı paylaşılamadı");
    // SHARED / CANCELLED → sistem sayfası zaten geri bildirim verdi, susuyoruz.
  };

  /* KAYDET — iyimser çevirme + sunucu yazımı; yazım düşerse GERİ ALINIR.
     Sessiz başarısızlık yok: kullanıcı hem eski ikonu geri görür hem toast. */
  const kaydetDegistir = async () => {
    if (!clip?.id) return;
    const oncekiDurum = isSaved;
    setIsSaved(!oncekiDurum);
    try {
      const { saved } = await toggleSave({
        contentId: clip.id,
        type: "clip",
        authorId: (clip?.authorId as string | undefined) || null,
        mediaUrl: klipPosterUrl(clip) || klipVideoUrl(clip) || null,
        caption: clip?.aciklama || "",
      });
      setIsSaved(!!saved);
    } catch (_) {
      setIsSaved(oncekiDurum);
      showToast("Kaydedilemedi, tekrar dene");
    }
  };

  return (
    <article className="clipDk-card">
      <header className="clipDk-header">
        <img
          src={avatarUrl}
          alt={username}
          className="clipDk-avatar"
          onClick={() => onUserClick?.(clip.authorId as string)}
          draggable="false"
        />
        <span
          className="clipDk-username"
          onClick={() => onUserClick?.(clip.authorId as string)}
          title={username}
        >
          {username}
        </span>
        {/* P0-2 — `⋯` ARTIK BİR MENÜ AÇIYOR.
            ÖLÇÜLEN KUSUR (denetim §2): düğmenin `onClick`i YOKTU; basılıyor,
            hiçbir şey olmuyordu. Menü içeriği ve a11y sözleşmesi `PostMobile`
            kebabıyla aynı (`aria-haspopup` + `aria-expanded` + `role=menu`);
            "Şikayet et" kendi klibinde GÖSTERİLMEZ — sunucu da öz-şikayeti
            reddediyor, olmayacak bir eylemi teklif etmeyiz (emsal: aynı
            dosyadaki öz-puanlama kapısı). */}
        <div className="clipDk-more" ref={menuRef}>
          <button
            className="clipDk-optionsBtn pressable"
            onClick={() => setMenuAcik((v) => !v)}
            aria-haspopup="menu"
            aria-expanded={menuAcik}
            aria-label="Klip seçenekleri"
          >
            {/* `KLIP_MOTOR_BOYUT_28`: kutu ölçüsü stil sayfasından buraya
                taşındı (üstteki blok) — motor kolunda 28→24 büzülmesi olmasın. */}
            <IkonKoprusu aile="action.more" {...KLIP_MOTOR_BOYUT_28} eski={<BsThreeDots />} />
          </button>
          {menuAcik && (
            <div className="clipDk-menu" role="menu">
              <button
                className="clipDk-menu-item pressable"
                role="menuitem"
                onClick={() => { setMenuAcik(false); onViewClip?.(clip); }}
              >Klibe git</button>
              {!kendiKlibim && (
                <button
                  className="clipDk-menu-item pressable"
                  role="menuitem"
                  onClick={() => {
                    setMenuAcik(false);
                    setSikayetHedefi({
                      targetType: REPORT_TARGET_TYPE.CLIP,
                      targetId: String(clip?.id || ""),
                    });
                  }}
                >Şikayet et</button>
              )}
              <button
                className="clipDk-menu-item pressable"
                role="menuitem"
                onClick={() => setMenuAcik(false)}
              >Vazgeç</button>
            </div>
          )}
        </div>
      </header>

      <div className="clipDk-media" onClick={() => onViewClip?.(clip)}>
        {/* T3 · P3-1 — ▶ ROZETİ.
            IG'de akışa düşen bir Reel, fotoğraf kartından **ilk bakışta**
            ▶ rozetiyle ayrılır (kaynak: `docs/denetim/IG_REFERANS_AKIS.md` §4).
            Bizde HİÇBİR işaret yoktu: kullanıcı kartın klip olduğunu ancak
            video oynamaya başlayınca anlıyordu — ve `preload` maliyet moduna
            göre kapalı olabildiği için bazen hiç anlamıyordu.
            Süre YALNIZ biliniyorsa yazılır (`klipSureMetni` boş dize döner);
            uydurulmuş bir "0:00" basmaktansa yalnız ▶ gösterilir.
            `pointer-events: none` (CSS): rozet, medyanın tıklama alanını
            DELMEZ — kartın tek dokunma sözleşmesi (`onViewClip`) korunur. */}
        <span
          className="clipDk-reelBadge"
          role="img"
          aria-label={sureMetni ? `Klip · ${sureMetni}` : 'Klip'}
        >
          <IkonKoprusu aile="media.play" eski={<BsPlayFill aria-hidden="true" />} />
          {sureMetni ? <span className="clipDk-reelDur">{sureMetni}</span> : null}
        </span>
        <MyClipsPlayer {...({
          clipId: clip.id,
          // 🔴 ÖLÇÜLDÜ (2026-08-25): bu üç satır YALNIZ eski adları okuyordu.
          // V3 hattı `v3_hlsManifestUrl` + `v3_posterUrl` yazıyor; transcoder'da
          // `manifestUrl` adı 0 kez geçiyor. Sonuç ana akışta iki kayıp birden:
          //   · `useHls` DAİMA false → ABR/HLS hiç kullanılmıyor, ham video iniyor
          //   · `poster` DAİMA undefined → kapak yok, ilk kareye kadar siyah
          // Ana akışa yalnız V3 klipleri giriyor (sorgu `v3_uploadedVia=="v3"`),
          // yani kayıp KOHORTUN TAMAMINI kapsıyordu.
          manifestUrl: klipManifestUrl(clip) || undefined,
          posterUrl: klipPosterUrl(clip) || undefined,
          fallbackUrl: klipVideoUrl(clip),
          muted: isMuted,
          loop: true,
          preload: videoPreload,
          className: "clipDk-video",
        } as any)} />
        <button className="clipDk-vol pressable" onClick={toggleMute} aria-label={isMuted ? 'Sesi aç' : 'Sesi kapat'}>
          {isMuted ? <IkonKoprusu aile="media.mute" eski={<VscMute />} /> : <IkonKoprusu aile="media.volume" eski={<VscUnmute />} />}
        </button>
      </div>

      <div className="clipDk-content">
        {/* EYLEM ŞERİDİ — ORTAK SUNUM BİLEŞENİ (owner, 2026-09-14).
            Klip kartının DOM'u değişmedi (hücresiz şerit, `clipDk-icon`,
            kaydette ek `clipDk-save`); ortaklaşan şey SIRA + ÖLÇÜ + dokunma.
            ⚠️ Yıldız tetiği `clip?.authorId` YOKKEN hiç çizilmez — o koşul
            korunuyor (aksi hâlde `contentId`siz bir tetik doğardı). */}
        <PostActionsBar
          onek="clipDk"
          sayiBicimle={formatCount}
          yildiz={
            clip?.authorId ? (
              <StarRatingV2
                className="clipDk-actionBtn clipDk-rate"
                /* T3 — 22 → 24: 5★ ürünün TEK kalite sinyali; kart tipine
                   göre küçülüp büyümemeli (gönderi kartlarıyla aynı). */
                size={24}
                contentId={clip.id}
                authorId={clip.authorId}
                type="clip"
                disabled={kendiKlibim}
                disabledReason={OZ_PUANLAMA_SEBEBI_KLIP}
              />
            ) : null
          }
          onYorum={() => onViewClip?.(clip)}
          eskiYorum={<BsChat className="clipDk-icon" />}
          /* P0-2 — `onClick` EKSİKTİ (denetim §2 · `:182`). */
          onPaylas={paylas}
          eskiPaylas={<FiSend className="clipDk-icon" />}
          /* P0-2 — eskiden YALNIZ `setIsSaved`: yerel state, sunucuya yazım
             yok → yenileyince kayıt kayboluyordu. */
          onKaydet={kaydetDegistir}
          kaydedildi={isSaved}
          eskiKaydet={isSaved ? <BsBookmarkFill className="clipDk-icon" /> : <BsBookmark className="clipDk-icon" />}
        />

        {/* PR-30 — GERÇEK rating aggregate: klip dokümanı üzerinde denormalize
            v3_ratingCount + v3_ratingAvg (bayes-smoothed) taşır → EKSTRA READ YOK.
            Eski beğeni sayısı ('X puan') değil. Yoksa sessiz kal.
            2026-08-25 — sayı TEK OTORİTEDEN geliyor: alan adlarını da, Bayes'i
            de, düşük-güven eşiğini de `klipYildizOtoritesi` bilir. Bu yüzeyin
            gösterdiği sayı artık MyClips rail'iyle BİREBİR aynıdır. */}
        {yildiz.count > 0 && (
          <div className="clipDk-rating" aria-label={yildiz.erisilebilirlik}>
            {yildiz.mod === "sayi" ? `${yildiz.metin}★` : yildiz.metin}
            {' · '}
            {yildiz.count.toLocaleString('tr-TR')} puan
          </div>
        )}
        {/* Sebep EKRANDA da yazar (emsal `Post.tsx`): devre dışı düğmede
            `title` tooltip'i güvenilmez, `aria-label`ı da yalnız ekran
            okuyucu duyar. Metin, tetiğin erişilebilir adıyla BİREBİR aynı
            → WCAG 2.5.3 (Label in Name) ile çelişmez. Aksiyon ŞERİDİNİN
            İÇİNE değil altına konur: ikon sırası kaymasın. */}
        {/* Öz-puanlama sebebi ARTIK KALICI SATIR DEĞİL (2026-09-13, owner):
            *"Kalıcı açıklamayı gönderi akışından çıkar; puanlama yasağını
            koru ve gerekli açıklamayı ilgili etkileşimde erişilebilir
            biçimde göster."* Sebep `StarRatingV2` tetiğinde yaşıyor:
            erişilebilir ad + `title` + BASILINCA canlı bölge & toast
            (`sebebiDuyur`). Yasak değişmedi (tetik `aria-disabled`,
            popover açılmaz, firestore.rules kilidi yerinde). */}
        {/* T3 — AÇIKLAMA KISALTMA ("devamı").
            ÖLÇÜLEN KUSUR (denetim §2, «Açıklama | kısaltma + more | tam metin,
            kısaltma yok | EKSİK»): klip kartı 2200 karaktere kadar açıklamayı
            TAM basıyordu → uzun açıklamalı bir klip ekranı doldurup altındaki
            kartı akıştan itiyordu. Gönderi kartlarında bu 2. turda kapatıldı
            (P1-1), klip kartında AÇIK kalmıştı. Aynı hat, aynı eşik. */}
        {aciklamaTam && (
          <p className="clipDk-caption">
            <strong onClick={() => onUserClick?.(clip.authorId as string)}>{username}</strong>
            <span> {aciklamaAcik ? aciklamaTam : aciklamaOnizleme}</span>
            {needsClamp && !aciklamaAcik && (
              <>
                <span>… </span>
                <button
                  className="clipDk-moreBtn pressable"
                  onClick={() => setAciklamaAcik(true)}
                  aria-label="Devamını göster"
                >
                  devamı
                </button>
              </>
            )}
          </p>
        )}
        {/* T3 — "Tüm N yorumu gör" (IG «View all N comments»).
            Gönderi kartlarında 2. turda açıldı (P1-1); klip kartında yorumlara
            giden TEK giriş 💬 ikonuydu ve kaç yorum olduğu HİÇ yazmıyordu.
            Hedef, 💬 ile BİREBİR aynı (`onViewClip`) — iki farklı yol, tek
            varış (kanon: aynı eylemin iki yüzeyi ayrışmasın).
            Sayı sıfırsa satır HİÇ basılmaz (IG de basmaz). */}
        {yorumAdet > 0 && (
          <button className="clipDk-commentsLink pressable" onClick={() => onViewClip?.(clip)}>
            Tüm {formatCount(yorumAdet)} yorumu gör
          </button>
        )}
        {/* T3 — ZAMAN DAMGASI.
            ÖLÇÜLEN KUSUR (denetim §2, «Zaman damgası | ✓ | YOK»): akıştaki
            klip kartı içeriğin NE ZAMAN paylaşıldığını hiç söylemiyordu; hemen
            üstündeki/altındaki gönderi kartı söylüyordu. Aynı `<time>`
            sözleşmesi (makine-okunur `dateTime` + tam tarih `title`) ve aynı
            biçimleyici — yeni bir zaman biçimi DOĞMUYOR (P2-1'in dersi). */}
        {/* Koşullu: `formatTimeAgoShort` tarih yok/bozuksa BOŞ DİZE döner ve
            `.clipDk-time` alt boşluk taşıdığı için boş bir `<time>` kartın
            dibinde ölü bir bant bırakırdı. Üç hâl ayrı: metin var → yaz,
            metin yok → satırı hiç açma (uydurma tarih YOK). */}
        {zamanMetni ? (
          <time
            className="clipDk-time"
            dateTime={damgaAttr(clip?.tarih)}
            title={baslikAttr(clip?.tarih)}
          >
            {zamanMetni}
          </time>
        ) : null}
      </div>
      {/* P0-2 — şikayet yüzeyi: `PostMobile`/`Post` ile AYNI bileşen ve AYNI
          hat (callable + rate-limit + admin ekranı). Klip için hedef tipi
          şemada zaten vardı (`REPORT_TARGET_TYPE.CLIP`); akış kartında
          kullanıcı-tetikli tek moderasyon girişi YOKTU. */}
      <ReportModal
        open={!!sikayetHedefi}
        target={sikayetHedefi}
        onClose={() => setSikayetHedefi(null)}
      />
    </article>
  );
}

export default ClipInFeed;
